import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-data-sets-actions',
  templateUrl: './data-sets-actions.component.html',
  styleUrls: ['./data-sets-actions.component.css'],
  standalone: false
})
export class DataSetsActionsComponent {

   @Input() row!: any;
    @Input() isEntitledToDelete = false;
    @Input() isEntitledToCopy = false;
    @Input() isEntitledToPublish = false;
    @Output() action = new EventEmitter<{ action: string; row: any }>();

    onPrimaryClick(event: MouseEvent) {
      event.stopPropagation();
    }

    emit(action: string): void {
      this.action.emit({ action, row: this.row });
    }

}
